import React from "react";
import { Link } from "react-router-dom";
import products from "../data/products"; // Import products data

function Products() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl sm:text-4xl font-bold text-center mb-8">
        Our Products
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map((product) => (
          <div
            key={product.id}
            className="border p-4 rounded-lg shadow-md flex flex-col items-center"
          >
            {/* Product Image */}
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-40 object-cover rounded mb-4"
            />
            {/* Product Name */}
            <h2 className="text-lg font-semibold mb-2 text-center">
              {product.name}
            </h2>
            {/* View Details Button */}
            <Link
              to={`/products/${product.id}`}
              className="text-blue-500 hover:underline text-sm"
            >
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Products;
